export default __webpack_public_path__ + "static/media/pie_hoja_A4.e17235a0.png";